module.exports = __webpack_public_path__ + "img/banner.cc8934a7.png";